import { useState, useRef, useCallback } from "react";

const safeDo = fn => { try { return fn(); } catch (e) { } };

const useStorage = (storage, key, initialValue) => {
	// Get initial state from storage
	const initialState = safeDo(() => JSON.parse(storage?.getItem(key))) ?? initialValue;
	// Pass initial state function to useState so logic is only executed once
	const [ storedValue, setStoredValue ] = useState(initialState);
	const valueRef = useRef(storedValue);

	// Return a wrapped version of useState's setter function that ...
	// ... persists the new value to storage.
	const setValue = useCallback(next => {
		// Allow value to be a function so we have same API as useState
		const valueToStore =
            typeof next == "function" ? next(valueRef.current) : next;
		safeDo(() => storage?.setItem(key, JSON.stringify(valueToStore)));
		valueRef.current = valueToStore;
		setStoredValue(valueToStore);
	}, [ key, storage, valueRef ]);

	return [ storedValue, setValue ];
};

export const useLocalStorage = (key, initialValue) => {
	return useStorage(window?.localStorage, key, initialValue);
};

export const useSessionStorage = (key, initialValue) => {
	return useStorage(window?.sessionStorage, key, initialValue);
};
